export { default } from './MenuItem';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/MenuItem/index.js
// module id = 552
// module chunks = 2